import $ from 'jquery'

/**
 * Cards "View More" functionality
 * Handles expanding hidden cards when user clicks "View More" button
 */
export default function initCardsFunctions() {
  if ($('.js-view-more-cards').length) {
    handleViewMoreCards();
  }
}

function handleViewMoreCards() {
  const $doc = $(document);

  $doc.on('click', '.js-view-more-cards', function(e) {
    e.preventDefault();
    
    const $button = $(this);
    
    // Remove focus/active state from button
    $button.blur();
    
    const $grid = $button.closest('.cards').find('.js-cards-grid');
    const $hiddenCards = $grid.find('.js-hidden-card');
    const visibleCount = parseInt($grid.data('visible-count')) || 12;
    const expandCount = visibleCount; // Show same number as initial visible count
    
    // Find currently hidden cards
    const $cardsToShow = $hiddenCards.filter(':hidden').slice(0, expandCount);
    
    if ($cardsToShow.length > 0) {
      // Calculate remaining BEFORE showing cards
      const totalHidden = $hiddenCards.filter(':hidden').length;
      const remainingAfter = totalHidden - $cardsToShow.length;
      
      // Show the next batch of cards with smooth animation
      $cardsToShow.fadeIn(400, function() {
        // Announce to screen readers (only announce once, not for each card)
        if ($(this).is($cardsToShow.last())) {
          const announcedCount = $cardsToShow.length;
          announceToScreenReader(`${announcedCount} more posts revealed`);
        }
      });
      
      // Update button text and visibility
      if (remainingAfter > 0) {
        // Update button text with new count
        $button.find('.js-view-more-text').html(`Load More <span class="u-sr-only">(${remainingAfter} more)</span>`);
        $button.attr('data-remaining', remainingAfter);
      } else {
        // All cards shown, hide button
        $button.fadeOut(300, function() {
          $(this).remove();
        });
        
        // Update aria-expanded
        $button.attr('aria-expanded', 'true');
        
        // Announce completion to screen readers
        announceToScreenReader('All posts are now visible');
      }
    }
  });
}

/**
 * Announce changes to screen readers
 * Creates a temporary live region for accessibility
 */
function announceToScreenReader(message) {
  const $announcement = $('<div>', {
    'role': 'status',
    'aria-live': 'polite',
    'aria-atomic': 'true',
    'class': 'u-sr-only',
    'text': message
  });
  
  $('body').append($announcement);
  
  // Remove after announcement (screen readers have had time to read it)
  setTimeout(() => {
    $announcement.remove();
  }, 1000);
}

